export const getOrientacionEInformacionApiUrl = (pathname: string) => process.env.REACT_APP_SC_ORIETACION_INFORMACION_API_URL + pathname
